import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import logo from '../../assets/images/logo.png';

// Validation schema with Yup (replaces redux-form validation)
const validationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .required('Password is required'),
});

// Custom input component (replaces renderInput)
const CustomInput = ({ field, form, parentClass, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={parentClass || 'mb-3'}>
      <input
        {...field}
        {...props}
        className={`${props.className || 'form-control'} ${hasError ? 'error' : ''}`}
      />
      {hasError && (
        <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};


class Login extends Component {
  componentDidMount() {
    const contentWrapper = document.getElementById('contentWrapper');
    if (contentWrapper) {
      contentWrapper.style['margin-left'] = 0;
    }
  }

  componentWillUnmount() {
    const contentWrapper = document.getElementById('contentWrapper');
    if (contentWrapper) {
      contentWrapper.style['margin-left'] = '230px';
    }
  }

  handleSubmit = (values, { setSubmitting }) => {
    // Call parent onSubmit with form values
    this.props.onSubmit(values);
    setSubmitting(false);
  };

  render() {
    return (
      <div className="login-inner">
        <img src={logo} alt="partplay" />
        <div className="login-box-body">
          <p>Sign in to start your session</p>

          <Formik
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={validationSchema}
            onSubmit={this.handleSubmit}
          >
            {({ isSubmitting, isValid, dirty }) => (
              <Form>
                <Field
                  name="email"
                  type="email"
                  placeholder="Email"
                  component={CustomInput}
                  className="form-control"
                  parentClass="mb-3"
                />

                <Field
                  name="password"
                  type="password"
                  placeholder="Password"
                  component={CustomInput}
                  className="form-control"
                  parentClass="mb-3"
                />

                <div className='mb-3'>
                  <button
                    className="btn btn-bg w-100 "
                    type="submit"
                    disabled={this.props.isLoading || isSubmitting || !isValid}
                  >
                    {this.props.isLoading || isSubmitting ? (
                      <span className="spinner" />
                    ) : (
                      <span>Login</span>
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

export default Login;
